/* global axios */

import ApiClient from '../ApiClient';

class CopilotAPI extends ApiClient {
  constructor() {
    super('integrations/ai', { accountScoped: true });
  }

  getCoaching(conversationId) {
    return axios.post(`${this.url}/copilot`, {
      conversation_id: conversationId,
      action_type: 'coaching',
    });
  }

  getReplySuggestions(conversationId) {
    return axios.post(`${this.url}/copilot`, {
      conversation_id: conversationId,
      action_type: 'reply_suggestions',
    });
  }
}

export default new CopilotAPI();
